export const SET_MOVIESORIGIONAL = (state,MoviesOrigional) => {
    state.MoviesOrigional = MoviesOrigional;
}